import type { errorHandler } from '@wix/essentials';
import { Translate } from '../../services';
import { getExportAsyncJob } from '@wix/bex-utils/@wix/ambassador-fedinfra-exportservice-v1-export-async-job/http';

export const getExportAsyncJobErrors = ({
  translate: t,
  retryFn,
}: {
  translate: Translate;
  retryFn?: () => void;
}): errorHandler.ErrorCodesMap<typeof getExportAsyncJob> => {
  return {
    job_not_found: () => ({
      message: t('cairo.export.GetExportAsyncJob.job-not-found.error'),
      action: {
        text: t('cairo.error.tryAgain.cta'),
        onClick: retryFn,
      },
    }),
    get_async_job_internal: () => ({
      message: t('cairo.export.get-async-job.error.internal'),
      action: {
        text: t('cairo.error.tryAgain.cta'),
        onClick: retryFn,
      },
    }),
    method_endpoint_permission_denied: false,
  };
};
